export default __webpack_public_path__ + "static/dispatch-4-059fbc76a470f7f761ea0940c7edc32d.png";